<template>
    <div>
      <div class="grid grid-cols-12 gap-4">
        <div :class="`bg-gray-100 dark:bg-darkPrimary mb-4 rounded-md relative w-full pt-4 lg:pt-0 overflow-y-auto overflow-x-hidden col-span-12  ${needHelpButton.isClicked ? 'md:col-span-9': ''}`">
          <h1 class="py-4 w-full text-center text-2xl lg:text-2xl dark:text-darkTextLight font-semibold">
            Fee Agreement
          </h1>
          <b-row>
            <b-col cols="12" v-show="isFetching">
              <p class="text-center"><em>Loading Fee Agreement...</em></p>
            </b-col>
            <b-col cols="8">
              <div class="agreement_container" id="agreement" style="margin-left:auto; margin-right: auto; height: calc(100vh -  250px); overflow-y: scroll;"></div>
            </b-col>
          </b-row>
        </div>
        <NeedHelp v-if="needHelpButton.isClicked"/>
      </div>

<!--        <b-row>-->
<!--            <b-form-group style="margin-left: auto; margin-right: auto">-->

<!--                <b-button type="button" @click="save()" variant="primary" v-show="has_agreement" :disabled="isLoading">-->
<!--                    <span class="mr-2 d-inline-block">{{ isLoading ? 'Submitting Document...' : 'Submit Signed Document' }}</span>-->
<!--                    <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>-->
<!--                </b-button>-->

<!--            </b-form-group>-->
<!--        </b-row>-->
    </div>
</template>

<script>
/* eslint-disable */

    import NeedHelp from "./NeedHelp";
var $ = require("jquery");
    var SignaturePad = require('@/js/signaturepad');
    import swal from 'sweetalert';
import {mapActions, mapGetters} from 'vuex'


    export default {
      name:'FeeAgreement',
      components: {NeedHelp},

      computed:{
          ...mapGetters({
               feeAgreement:'client/feeAgreement',
              isEligible: 'client/isEligible',
              continueButton: 'client/continueButton',
              needHelpButton: 'client/needHelpButton'
          })
      },

        data : function(){
            return {
                has_agreement: false,
                agreement : null,
                terms : {},
                has_terms : false,
                attach : false,
                sigpad : null,
                signature:null,
                option:{
                    penColor:"rgb(0, 0, 0)",
                    backgroundColor:"rgb(255,255,255)"
                },
                client_errors : [],
                isLoading: false,
                isFetching: false,
                isConsultation: false
            }
        },

        methods : {
          ...mapActions({
            setNeedHelpButton: 'client/setNeedHelpButton',
            setContinueButton: 'client/setContinueButton',
            showFooter: 'client/setShowFooter'
          }),
          isEnabled(){
            const vm = this;
            if (this.isConsultation) {
              if((vm.terms.has_read_terms_of_business && vm.terms.acknowledge_and_consent_to_confidentiality ) || !this.has_terms) {
                this.setContinueButton({isClicked: false, isEnabled: true, text: 'Submit'});
              } else{
                this.setContinueButton({isClicked: false, isEnabled: false, text: 'Submit'});
              }
            } else {
              if((vm.terms.has_read_terms_of_business && vm.terms.acknowledge_and_consent_to_confidentiality && vm.terms.has_read_code_of_conduct && vm.terms.has_read_consumer_guide && vm.has_agreement) || !this.has_terms){
                this.setContinueButton({isClicked: false, isEnabled: true, text: 'Submit'});
              }else{
                this.setContinueButton({isClicked: false, isEnabled: false, text: 'Submit'});
              }
            }
          },
            clear() {
                this.sigpad.clear();
            },

            validate : function(){

                var vm = this;

                vm.client_errors = [];

                if(this.sigpad.isEmpty()){
                    var i = vm.client_errors.length;
                    vm.client_errors.push('Please attach your signature to the signature pad provided.');
                }

                if( vm.has_terms ){
                    if( vm.terms.has_read_terms_of_business == null || vm.terms.has_terms_of_business == false ){
                        vm.client_errors.push('Please acknowledge that you have read and understood the Consumer Guide from the Carman & Associates Terms of Business');
                    }

                    if( vm.terms.acknowledge_and_consent_to_confidentiality && (vm.terms.acknowledge_and_consent_to_confidentiality == null || vm.terms.acknowledge_and_consent_to_confidentiality == false) ){
                        vm.client_errors.push('Please acknowledge that you have read and understood the Confidentiality, Privacy and Group Information Sharing provisions');
                    }

                    if( vm.terms.has_read_consumer_guide && (vm.terms.has_read_consumer_guide == null || vm.terms.has_read_consumer_guide == false) ){
                        vm.client_errors.push('Please acknowledge that you have read and understood the Consumer Guide from the Migration Agents Registration Authority');
                    }

                    if( vm.terms.has_read_code_of_conduct && (vm.terms.has_read_code_of_conduct == null || vm.terms.has_read_code_of_conduct == false) ){
                        vm.client_errors.push('Please acknowledge that you have read and understood the Code of Conduct for Migration Agents');
                    }
                }

            },

            save() {

                var vm = this;

                vm.validate();

                if( vm.client_errors.length > 0 ){
                    var error_str = vm.client_errors.join("\n\n");
                    swal('Validation Error!', error_str  ,'error');
                    this.setContinueButton({isClicked: false, text: 'Submit'});
                    return false;
                }

                vm.signature = this.sigpad.toDataURL();

                var post = {};
                post['signature'] = vm.signature;

                // do not include this if no checkboxes
                if( vm.has_terms ){
                    post['terms'] = vm.terms;
                }

                this.isLoading = true;
                let faId = this.feeAgreement.id;
                this.$http.post( `${process.env.VUE_APP_BASE_URL}/${faId}/fee-agreement/sign` ,post)
                    .then((response)=>{
                        this.$router.push('/signed')
                        this.isLoading = false;
                }).catch((error)=>{
                    swal({
                        title: 'Error',
                        icon: 'error',
                        text: error.response.data.message
                    }).finally(() => {
                      this.setNeedHelpButton({isClicked: false, isEnabled: true});
                      this.isEnabled();
                    })
                    this.isLoading = false;
                    // swal("Validation Error!","Please make sure you acknowledge all the terms by checking the checkboxes.","error");
                });
            },


            downloadTerms : function(file){
                var vm  = this;
                this.downloading = true ;
                const faId = this.feeAgreement.id;
                this.$http({
                    url: process.env.VUE_APP_BASE_URL + '/'+faId+'/fee-agreement/terms/' + file ,
                    method : 'GET',
                    responseType : 'blob'
                })  .then( (response)=>{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file );
                    document.body.appendChild(link);
                    link.click();
                    vm.downloading = false;
                });
            }

        },

      watch: {
        continueButton: async function (val){
          if(val.isClicked){
            await this.save();
          }
        }
      },

        async created() {
            var vm = this;

          if(vm.feeAgreement.status === 'ineligible'){
            vm.$router.push('/fa/not-eligible');
          } else if (!vm.isEligible && vm.feeAgreement.hasEligibilities) {
            vm.$router.push('/eligibility');
          }
          else{
            this.isFetching = true;
            this.setContinueButton({isClicked: false, text: 'Submit', isEnabled: false});

            await this.$http.get( `${process.env.VUE_APP_BASE_URL}/${this.feeAgreement.id}/fee-agreement`).then(function(response){

              $('#agreement').html(response.data.document);

              vm.has_terms  = $('#agreement').find('input[type="checkbox"]').length > 0;

              if ($('#agreement').find('input[type="checkbox"]').length == 2) {
                vm.isConsultation = true;
              } else if ($('#agreement').find('input[type="checkbox"]').length > 1) {
                vm.terms = {
                  has_read_terms_of_business: null,
                  acknowledge_and_consent_to_confidentiality: null,
                  has_read_consumer_guide: null,
                  has_read_code_of_conduct: null,
                }
              }

              $("#agreement").find('#epg-migration-terms-of-business').click(function(event){
                event.preventDefault();
                vm.downloadTerms('xemplo-legal-migration-tc.pdf');
              });

              $("#agreement").find('#epg-consultation-terms-of-business').click(function(event){
                event.preventDefault();
                vm.downloadTerms('xemplo-legal-employment-law-tc.pdf');
              });

              $("#agreement").find('#code-of-conduct').click(function(event){
                event.preventDefault();
                vm.downloadTerms('Code-Of-Conduct.pdf');
              });

              $("#agreement").find('#consumer-guide').click(function(event){
                event.preventDefault();
                vm.downloadTerms('Consumer-Guide-English.pdf');
              });

              $("#agreement").find('#i-have-read-terms-of-business').change(function(){
                vm.terms.has_read_terms_of_business = $(this).is(':checked');
                vm.isEnabled();
              });

              $("#agreement").find('#i-acknowledge-and-consent-to-confidentiality').change(function(){
                    vm.terms.acknowledge_and_consent_to_confidentiality = $(this).is(':checked');
                    vm.isEnabled();
                });

              $("#agreement").find('#i-have-read-code-of-conduct').change(function(){
                vm.terms.has_read_code_of_conduct = $(this).is(':checked');
                vm.isEnabled();
              });

              $("#agreement").find('#i-have-read-consumer-guide').change(function(){
                vm.terms.has_read_consumer_guide = $(this).is(':checked');
                vm.isEnabled();
              });


              $("#agreement").find("#btnAttach").click(function(event){
                event.preventDefault();
                vm.attach = true;
              });
              $("#agreement").find("#clear").addClass('mb-2');
              $("#agreement").find("#clear svg").addClass('clear-svg')
              $("#agreement").find("p").addClass('p-agreement');
              $("#agreement").find("h5").addClass('h5-agreement');
              $("#agreement").find("td").addClass('table-agreement');
              $("#agreement").find("#clear").click(function(event){
                event.preventDefault();
                vm.clear();
              });
              $("#agreement").find("#clear").children('svg').height(16);

              let canvas = document.querySelector('canvas');

              vm.sigpad = new SignaturePad(canvas, {
                dotSize:1,
                onEnd: () => {
                  vm.$emit('sig-input', vm.sigpad.toDataURL());
                }
              });

              var ratio =  Math.max(window.devicePixelRatio || 1, 1);

              // This part causes the canvas to be cleared
              canvas.width = canvas.offsetWidth * ratio;
              canvas.height = canvas.offsetHeight * ratio;
              canvas.getContext("2d").scale(ratio, ratio);
              vm.has_agreement = true;
            }).then(() => {
              if(!this.has_terms){
                this.setContinueButton({isClicked: false, text: 'Submit', isEnabled: true});
              }
            }).catch(error => {
              swal({
                title: 'Error',
                icon: 'error',
                text: error.response.data.message
              }).finally(() => {
                this.isEnabled();
              })
            });
            this.showFooter(true);
            this.isFetching = false;
          }
       }
    }
</script>

<style type="text/css">

    .table td, .table th {
        padding: 5px 0;
    }

    .page{
      position: relative;
      padding: 20mm;
      background: white;
      display: block;
      margin: 0 auto;
      margin-bottom: 0.5cm;
      border: 1px solid #eee;
      border-radius: 12px;
      width: 21cm;
      min-height: 29.7cm;
      font-size: 14px;
    }

    .page-footer {

        position: absolute;
        left: 0;
        bottom: 0.5cm;
        font-size: .8em;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }

    .page h1{
        font-size: 18px;
    }
    .page h3{
        font-size: 16px;
    }
    .page h4,.page h5{
        font-size: 16px;
        margin: 5px 0;
    }

    #btnAttach {
        margin-top: 25px;
    }

    #signature {
        border: 1px solid #ccc;
        margin: 20px;
        width: 100%;
    }

    #signature-options {
       margin: 0;
    }

    #scope_of_work {
       border: 1px solid #ccc;
        padding: 5px;
        margin-bottom: 10px;
    }

    .total_cost {
       font-weight: bold;
    }

    #signature-options .col {
        padding: 0;
    }

    .h5-agreement{
      margin-top: 2rem !important;
      margin-bottom: 2rem !important;
      font-weight: 800;
    }
    table{
      width: 100%;
    }
    .table-agreement{
      background-color: white;
    }
    p + table > tbody > tr > td.table-agreement{
      border-width: 3px !important;
      border-color: black !important;
      border-style: solid !important;
    }

    .p-agreement{
      margin-top: 1rem;
    }

    #scope_of_work{
      border-style: none;
    }

    #scope_of_work > h4{
      font-weight: 800;
    }

    .clear-svg{
      height: 16px;
      width: 16px;
      margin-right: 0.5rem;
    }

    .p-agreement > img{
      margin: auto;
    }

</style>
